import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ListTable, { ListTableActions, ListTableColumn } from '../../shared/listView/ListTable';
import ListTableNameCell from '../../shared/listView/ListTableNameCell';
import { recipeNameService } from '../../services/recipeNameService';
import DeleteItemIcon from '../../shared/DeleteItemIcon';
import EditItemIcon from '../../shared/EditItemIcon';
import { recipeDeleteService } from '../../services/recipeDeleteService';
import { POPUP_KEY_DELETE_RECIPE } from '../../constant';
import { MAIN_RECIPE_ELEMENTS } from '../helper';
import useWindowDimensions from '../../hooks/useWindowDimension';
import { Recipe } from '../../services/recipeTypes';

type RecipeTableProps = {
    items: Recipe[];
    isLoading?: boolean;
};

const RecipeTable = ({ items, isLoading = false }: RecipeTableProps) => {
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    const { width } = useWindowDimensions();

    const editUrl = (id: string) => `/recipe/item/${id}/?ingredientTab=${MAIN_RECIPE_ELEMENTS}`;

    const columns = useMemo<ListTableColumn<Recipe>[]>(() => [
        {
            id: 'name',
            header: i18n.t('app.page.listView.name'),
            cell: (row) => (
                <ListTableNameCell itemCode={row} itemService={recipeNameService} />
            ),
        },
        {
            id: 'type',
            header: i18n.t('app.page.listView.type'),
            cell: (row) => <span className="list-table__code">{row.recipeType}</span>,
        },
        {
            id: 'actions',
            header: i18n.t('app.page.listView.actions'),
            className: 'list-table__td_actions',
            cell: (row) => (
                <ListTableActions>
                    <EditItemIcon pageUrl={editUrl(row.id)} />
                    <DeleteItemIcon
                        itemId={row.id}
                        itemDeleteService={recipeDeleteService}
                        popupKey={POPUP_KEY_DELETE_RECIPE}
                    />
                </ListTableActions>
            ),
        },
    ], [i18n]);

    return (
        <ListTable
            columns={columns}
            rows={items}
            rowKey={(row) => row.id}
            width={width}
            isLoading={isLoading}
            onRowClick={(row) => navigate(editUrl(row.id))}
        />
    );
};

export default RecipeTable;
